module.exports = __webpack_public_path__ + "static/music-works-ebac9588064186cd58377ced054ee387.png";